import * as React from 'react';
import * as info from "./style.module.scss";
import { Breadcrumbs } from "../Breadcrumbs";
export const Info = ({ subPageName, data }) => {
  return (
    <section className={info.info}>
      <div className="container">
        <Breadcrumbs subPageName={subPageName}/>
        {data.map((elem, index) => (
          <div className="row" key={index}>
            <div className={`col-12 col-lg-8 ${info.col}`}>
              <h1>
                Субтитры на английском языке к сериалу { subPageName }
              </h1>
              <div className={info.desc}>
                <p>({elem.name})</p>
                <p><strong>{elem.desc}</strong></p>
                <span>Creator: {elem.creator}</span>
                <br/>
                <span>Stars: {elem.stars}</span>
              </div>
            </div>
            <div className={`col-12 col-md-4 ${info.col}`}>
              <div className={info.img}>
                <img src={elem.img} alt={`${elem.name}`}/>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
